import Api from '@/api/Api'

export default {
  getCurrentEuro () {
    return Api().get('Payment/get_current_euro/')
  },

  paySnap (params) {
    return Api().post('Payment/pay_snap/', params)
  },
  postSnapPayment (params) {
    return Api().post('Payment/post_snap_payment/', params)
  },

  paymentOrderBankTrf (params) {
    return Api().post('Payment/payment_order_bank_trf/', params)
  },
  confirmPaymentOrderBankTrf (params) {
    return Api().post('Payment/confirm_payment_order_bank_trf/', params)
  },
  confirmByAdmin (params) {
    return Api().post('Payment/confirm_by_admin/', params)
  },
  fetchPaymentList (params) {
    return Api().post('Payment/fetch_payment_list/', params)
  },
  fetchByParam (params) {
    return Api().post('Payment/fetch_by_param/', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/PaymentAPI.js